import Vue from 'vue';
import Vuex from 'vuex';
import frame from './modules/frame';
import app from './modules/app';
import user from './modules/user';
import copyer from './modules/copy';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    frame,
    app,
    user,
    copyer,
  },
});

export default store;
